export default __webpack_public_path__ + "static/media/kamarajar.615a086b.png";